import { useState } from 'react';
import helperAdmin from '../../../utils/helperAdmin';

function removeItems(arr, item) {
  for (var i = 0; i < item; i++) {
    arr.pop();
  }
}

function useFiles({ initialState = [], maxFiles }) {
  const [state, setstate] = useState(initialState);
  function withBlobs(files) {
    const destructured = [...files];
    if (destructured.length > maxFiles) {
      const difference = destructured.length - maxFiles;
      removeItems(destructured, difference);
    }
    const blobs = destructured
      .map(file => {
        const fileNameDestructured = file.name.split('.');
        const extension = fileNameDestructured[fileNameDestructured.length - 1]
        if(!helperAdmin['supportExcelFiles'].includes(extension)) return null;
        else return file;
        // if (file.type.includes("image")) {
        //   console.log("image");
        //   file.preview = URL.createObjectURL(file);
        //   return file;
        // }
        // console.log("not image");
        // return null;
      })
      .filter(elem => elem !== null);

    setstate(blobs);
  }
  return [state, withBlobs];
}

export default useFiles
